import React from "react";
const Banner = ({ children }) => {
    return React.createElement("div", { className: "banner" }, children);
};
export default Banner;
